<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="外部供应商报价查询">
        <span slot="label"><i class="iconfont icon-search" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_quote_search")}}</span>
        <VendPurchaseQuoteOutSearch></VendPurchaseQuoteOutSearch>
      </el-tab-pane>
      <el-tab-pane label="新建外部供应商报价">
        <span slot="label"><i class="iconfont icon-edit" style="font-size: 14px"></i>&nbsp;{{$t("tab.tab_vend_quote_create")}}</span>
        <VendPurchaseQuoteOutAdd></VendPurchaseQuoteOutAdd>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import VendPurchaseQuoteOutSearch from "./VendPurchaseQuoteOutSearch";
import VendPurchaseQuoteOutAdd from "./VendPurchaseQuoteOutAdd";

export default {
  name: "VendPurchaseQuote",
  components: {
    VendPurchaseQuoteOutSearch,
    VendPurchaseQuoteOutAdd,
  },
  data() {
    return {
      tab_index: 0,
    };
  },
  created() { },
  methods: {},
};
</script>
